///
/// EarthBrowser
///
/// Migration v30 to v31: Remove minimized window tiles
/// Created by Matt Giger on September 6, 2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v30 to v31
 *
 * Changes:
 * - Removes userInterface.minimizedTilePositions (minimized tiles retired;
 *   windows now dock into the bottom drawer instead of minimizing)
 * - Strips the isMinimized field from persisted window states; windows that
 *   were saved as minimized are marked docked so they restore as drawer tabs
 */
interface PersistedWindowStateV30 {
	isMinimized?: boolean
	isDockedInDrawer?: boolean
}

interface UserInterfaceV30 {
	minimizedTilePositions?: unknown
	persistedWindowStates?: Record<string, PersistedWindowStateV30>
}

interface StateV30 {
	userInterface?: UserInterfaceV30
}

export function migrateV30toV31(state: unknown): unknown {
	const s = state as StateV30 | null | undefined
	if (!s?.userInterface) return state

	const userInterface = { ...s.userInterface }
	delete userInterface.minimizedTilePositions

	const oldWindowStates = userInterface.persistedWindowStates
	if (oldWindowStates && typeof oldWindowStates === "object") {
		const persistedWindowStates: Record<string, PersistedWindowStateV30> = {}
		for (const [id, windowState] of Object.entries(oldWindowStates)) {
			if (!windowState || typeof windowState !== "object") continue
			const { isMinimized, ...rest } = windowState
			persistedWindowStates[id] = {
				...rest,
				// Previously minimized windows become drawer tabs
				isDockedInDrawer: rest.isDockedInDrawer || isMinimized === true,
			}
		}
		userInterface.persistedWindowStates = persistedWindowStates
	}

	return {
		...s,
		userInterface,
	}
}
